export default __webpack_public_path__ + "static/media/888holdings.917723eb.gif";